import React from 'react';
import { CellCard, CellRadio } from '@root/components/Cell';
import useSelectCountry from '@root/hooks/login/useSelectCountry';
import SafeAreaInset from '@root/components/SafeAreaInset';

const SelectCountry = () => {
  const { country, countriesData, onChange } = useSelectCountry();

  return (
    <>
      <CellCard marginTop={20}>
        {countriesData.map((item) => (
          <CellRadio
            inner
            key={item.id}
            value={item.id}
            title={item.name}
            checked={item.id === country}
            onClick={() => onChange(item.region, item.id)}
          />
        ))}
      </CellCard>
      <SafeAreaInset />
    </>
  );
};

export default SelectCountry;
